import type { ReactNode } from 'react';
import { useAuth } from '@/auth/AuthProvider';
import type { PermissionKey } from '@/auth/permissions';

/** Renders children only when the caller holds `perm` (write implies read). */
export function Can({ perm, children, fallback = null }: { perm: PermissionKey; children: ReactNode; fallback?: ReactNode }) {
  const { permissions } = useAuth();
  return <>{permissions.has(perm) ? children : fallback}</>;
}

/** Hook form of <Can>. */
export function useCan(perm: PermissionKey): boolean {
  return useAuth().permissions.has(perm);
}
